export default __webpack_public_path__ + "static/media/img-11.283b0725.jpg";